import React from 'react'
import { useNavigate } from 'react-router-dom';
import loadImg from "@Images/NewUI/loading_glass.gif";

const Kycprofileinreview = (props) => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate("/super-loan-dashboard");
  };

  return (
   <>
   

   <div className='container'>
   <div className="wrapper-content kyc_margin">
                    <div className="kyccard-height px-4 pb-3 pt-1 w-100 text-center mx-auto  rounded-40 ">
                      <div className="d-flex flex-column justify-content-between">
                        <div className="pt-4 pb-5">
                        <img
                            src={loadImg}
                            alt="loadImg"
                            className="pop_kyc"
                        />
                        <h1  className='kycVerificationfont'>Profile in Review</h1>
                        <p className='kycparagraph'>Our team is verifying your profile.<br/>Please try after sometime.</p>
                        </div>
                      </div>
                    </div>
                    <div className="text-center pt-4 setmoney_div">
                        <div
                        className="GetNowBtnrepayvd"
                        onClick={handleBackToHome}
                        >
                        Back to Home
                        </div>
                      </div>
                    
    </div>
   </div>
   </>
  )
}

export default Kycprofileinreview